<template>
    <div class="ssl-box">
        <el-dialog
            :title="$t('components.AiErSSL.title')"
            center
            :visible.sync="sslDialogVisible"
            :width="width||'40%'"
            v-if="sslDialogVisible"
            @close="closeClick">
            <!-- 自定义中间内容 -->
            <div class="desc-box">
                <div class="header">
                    {{ $t('components.AiErSSL.downloadTip') }}
                </div>
                <div class="content">
                    <ul>
                        <li>{{ $t('components.AiErSSL.tipStep1') }}</li>
                        <li>{{ $t('components.AiErSSL.tipStep2') }}</li>
                    </ul>
                </div>
                <div class="footer">
                    <img @click="downFile('aierchina-self-signed.crt')" :src="crt" alt="">
                </div>
            </div>
            
        </el-dialog>

    </div>
</template>

<script>
import ssl from '@/assets/ssl.png'
import crt from '@/assets/self-signed-ssl-cert.png'
import {downFile} from '@/api/index'
export default {
    props: {
        // visible: Boolean,
        width: String,

    },
    data() {
        return {
            sslDialogVisible: true,
            ssl: ssl,
            crt: crt
        };
    },
    // computed: {
    //     sslDialogVisible: {
    //         get() {
    //             return this.visible
    //         },
    //         set (val) {
    //             this.$emit('updateJoinVisible',val)
    //         }
    //     }
    // },
    methods: {
        async downFile(url) {
            const a = document.createElement('a');
            a.href = './file/' + url;
            a.download = url;
            // 障眼法藏起来a标签
            a.style.display = 'none';
            // 将a标签追加到文档对象中
            document.body.appendChild(a);
            // 模拟点击了<a>标签,会触发<a>标签的href的读取,浏览器就会自动下载了
            a.click();
        },
        closeClick() {
            this.sslDialogVisible = false
            this.$el.parentNode.removeChild(this.$el);//清除dom元素
            // this.$emit('closeClick')
        },
        cancelClick() {
            this.sslDialogVisible = false

            this.$el.parentNode.removeChild(this.$el);//清除dom元素
            // this.$emit('cancelClick')
        },
        saveClick() {
            this.sslDialogVisible = true

            this.$el.parentNode.removeChild(this.$el);//清除dom元素
            // this.$emit('saveClick')
        }
    },
};
</script>

<style lang="scss" scoped>
.ssl-box {
    .desc-box {
        // 这个属性可以保留，作为备用
        word-break: break-word; 

        .header, // 直接选中 p 标签
        .content { // 直接选中 li 标签
            font-size: 16px;
        }

        .content {
            margin-top: 10px;
        }

        .footer {
            margin-top: 15px;
            justify-content: space-around;
            text-align: center;
            img {
                cursor: pointer;
            }
        }
    }
}
</style>